var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8984 9.9375H11.0625C10.4409 9.9375 9.84476 9.69057 9.40522 9.25103C8.96568 8.81149 8.71875 8.21535 8.71875 7.59375V0.757812C8.71875 0.706012 8.69817 0.656334 8.66154 0.619706C8.62492 0.583078 8.57524 0.5625 8.52344 0.5625H4.03125C3.20245 0.5625 2.40759 0.89174 1.82154 1.47779C1.23549 2.06384 0.90625 2.8587 0.90625 3.6875V19.3125C0.90625 20.1413 1.23549 20.9362 1.82154 21.5222C2.40759 22.1083 3.20245 22.4375 4.03125 22.4375H14.9688C15.7976 22.4375 16.5924 22.1083 17.1785 21.5222C17.7645 20.9362 18.0938 20.1413 18.0938 19.3125V10.1328C18.0938 10.081 18.0732 10.0313 18.0365 9.99471C17.9999 9.95808 17.9502 9.9375 17.8984 9.9375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4697 8.20857L10.4478 1.1866C10.4341 1.17303 10.4167 1.16379 10.3978 1.16006C10.379 1.15632 10.3594 1.15826 10.3416 1.16561C10.3238 1.17297 10.3086 1.18543 10.2978 1.20141C10.2871 1.21739 10.2813 1.23619 10.2812 1.25545V7.59383C10.2812 7.80103 10.3636 7.99974 10.5101 8.14626C10.6566 8.29277 10.8553 8.37508 11.0625 8.37508H17.4009C17.4201 8.375 17.4389 8.36923 17.4549 8.35849C17.4709 8.34775 17.4834 8.33253 17.4907 8.31474C17.4981 8.29694 17.5 8.27737 17.4963 8.25848C17.4925 8.23959 17.4833 8.22223 17.4697 8.20857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.ab4dda82385513688704a66d4f3552c8.svg";
export { ForwardRef as ReactComponent };